import { Button, Typography } from 'darrius';

import * as Dialog from '../Dialog/Dialog';

import styles from './CreditCardErrorModal.module.scss';

const DEFAULT_DESCRIPTION =
  'Não conseguimos concluir o pagamento com o seu cartão, mas você ainda pode garantir suas moedas. Divida o pagamento com o Pix parcelado — sem cartão, de forma rápida e segura.';

const DEFAULT_CONFIRM_LABEL = 'Pagar com Pix parcelado';

interface ICreditCardErrorModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onRedirectToPixInstallments: () => void;
  /** Texto do corpo. Por padrão, o mesmo da compra de moedas. */
  description?: string;
  /** Texto do botão. Por padrão, o mesmo da compra de moedas. */
  confirmLabel?: string;
}

export const CreditCardErrorModal = ({
  isOpen,
  onOpenChange,
  onRedirectToPixInstallments,
  description = DEFAULT_DESCRIPTION,
  confirmLabel = DEFAULT_CONFIRM_LABEL,
}: ICreditCardErrorModalProps) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Content
          className={styles['credit-card-error-modal']}
          title={{
            text: 'Compra não autorizada',
            hidden: true,
          }}
        >
          <Dialog.Close />

          <div className={styles['credit-card-error-modal__image']}>
            <img
              src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/check-credit-card.svg`}
              alt="Ilustração de cartão de crédito"
            />
          </div>

          <Typography.Subtitle size="l" className="center-sm">
            Compra não autorizada
          </Typography.Subtitle>

          <Typography.Text
            className={`${styles['credit-card-error-modal__text']} center-sm`}
          >
            {description}
          </Typography.Text>

          <Button.Root
            fullWidth
            size="small"
            onClick={onRedirectToPixInstallments}
          >
            {confirmLabel}
          </Button.Root>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
